import ReactPlayer from 'react-player'

const VideoPlayer = ({ record }) => {
  return <ReactPlayer controls url={record.src || record.undefined} />
}

export default VideoPlayer
